module.exports = __webpack_public_path__ + "static/media/34.a177bde9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/34.jpg
// module id = 595
// module chunks = 0